import React from 'react';
import { CheckIcon, CreditCardIcon, ShieldIcon, MailIcon } from 'lucide-react';
export const CallToAction = () => {
  return <section id="comprar" className="py-16 px-4 sm:px-6 lg:px-8 bg-teal-50" data-id="element-60">
      <div className="max-w-6xl mx-auto" data-id="element-61">
        <div className="text-center mb-10" data-id="element-62">
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-63">
            Empezá hoy y resolvé la cena de esta misma noche
          </h2>
          <p className="text-xl text-gray-700" data-id="element-64">
            Porque postergar... es seguir en piloto automático.
          </p>
        </div>
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden" data-id="element-65">
          <div className="grid grid-cols-1 md:grid-cols-2" data-id="element-66">
            <div className="p-6 lg:p-10" data-id="element-67">
              <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center md:text-left" data-id="element-68">
                Descargá el Recetario Fit + 6 Bonos
              </h3>
              <div className="space-y-4 mb-6" data-id="element-69">
                <div className="flex items-start gap-3" data-id="element-70">
                  <CheckIcon className="h-6 w-6 text-teal-600 flex-shrink-0 mt-0.5" data-id="element-71" />
                  <p className="text-gray-700" data-id="element-72">
                    +60 recetas para airfryer en menos de 15 minutos
                  </p>
                </div>
                <div className="flex items-start gap-3" data-id="element-73">
                  <CheckIcon className="h-6 w-6 text-teal-600 flex-shrink-0 mt-0.5" data-id="element-74" />
                  <p className="text-gray-700" data-id="element-75">Plan completo de 4 semanas</p>
                </div>
                <div className="flex items-start gap-3" data-id="element-76">
                  <CheckIcon className="h-6 w-6 text-teal-600 flex-shrink-0 mt-0.5" data-id="element-77" />
                  <p className="text-gray-700" data-id="element-78">Macros calculados por porción</p>
                </div>
                <div className="flex items-start gap-3" data-id="element-79">
                  <CheckIcon className="h-6 w-6 text-teal-600 flex-shrink-0 mt-0.5" data-id="element-80" />
                  <p className="text-gray-700" data-id="element-81">Listas de compras imprimibles</p>
                </div>
                <div className="flex items-start gap-3" data-id="element-82">
                  <CheckIcon className="h-6 w-6 text-teal-600 flex-shrink-0 mt-0.5" data-id="element-83" />
                  <p className="text-gray-700 font-semibold" data-id="element-84">
                    6 bonos exclusivos valorados en $89.940
                  </p>
                </div>
              </div>
              <div className="space-y-3 mb-6" data-id="element-85">
                <div className="flex items-center gap-3" data-id="element-86">
                  <CreditCardIcon className="h-5 w-5 text-gray-600" data-id="element-87" />
                  <p className="text-gray-700" data-id="element-88">
                    Compra segura por Mercado Pago / transferencia
                  </p>
                </div>
                <div className="flex items-center gap-3" data-id="element-89">
                  <MailIcon className="h-5 w-5 text-gray-600" data-id="element-90" />
                  <p className="text-gray-700" data-id="element-91">Entrega inmediata por mail</p>
                </div>
                <div className="flex items-center gap-3" data-id="element-92">
                  <ShieldIcon className="h-5 w-5 text-gray-600" data-id="element-93" />
                  <p className="text-gray-700" data-id="element-94">Garantía 7 días "sin vueltas"</p>
                </div>
              </div>
              <div className="mt-8 flex justify-center md:justify-start" data-id="element-95">
                <a href="https://vhwt09-gz.myshopify.com/checkouts/cn/hWN3ajyOi9gyqJJTJgcXUW4g/es-ar?cart_link_id=CISumiVv&preview_theme_id=133233049643" className="block w-full bg-teal-600 hover:bg-teal-700 text-white font-bold py-4 px-6 rounded-lg shadow-lg hover:shadow-xl transition duration-300 text-center text-xl" data-id="element-96">
                  Quiero todo hoy por $19.990
                </a>
              </div>
              <p className="text-sm text-gray-500 mt-3 text-center" data-id="element-97">
                Hecho para Argentina. Para tu rutina real.
              </p>
            </div>
            <div className="hidden md:block relative" data-id="element-98">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/g8mk3YbyRU94E3wuaw6Rf3/81a7378d-a0eb-4498-afdd-408dd63002dc.png" alt="Comida saludable preparada con Airfryer" className="absolute inset-0 w-full h-full object-cover" data-id="element-99" />
            </div>
            <div className="block md:hidden p-4" data-id="element-100">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/g8mk3YbyRU94E3wuaw6Rf3/81a7378d-a0eb-4498-afdd-408dd63002dc.png" alt="Comida saludable preparada con Airfryer" className="w-full rounded-lg shadow-md" data-id="element-101" />
            </div>
          </div>
        </div>
        <div className="mt-6 text-center" data-id="element-102">
          <p className="text-gray-600 text-sm" data-id="element-103">
            Comprás una vez, recibís actualizaciones gratis para siempre.
          </p>
        </div>
      </div>
    </section>;
};